import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const usePageTracking = () => {
    const location = useLocation();
  
    useEffect(() => {
      const sendPageView = (path) => {
        window.gtag('config', 'G-5SM1H3F2YK', {
          page_path: path,
        });
      };
  
      sendPageView(location.pathname);
    }, [location]);
  };